import {ErrorMessage} from 'components/common/ErrorMessage'
import React from 'react'
import {addTrackingException} from 'utils/addTrackingError'

type Props = {
  children: React.ReactNode
}

type State = {
  error: unknown
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = {error: null}

  static getDerivedStateFromError(error: unknown): State {
    return {error}
  }

  componentDidCatch(error: unknown, errorInfo: React.ErrorInfo) {
    addTrackingException(error, {
      source: 'error_boundary',
      component_stack: errorInfo.componentStack,
    })
  }

  render() {
    if (this.state.error) {
      return <ErrorMessage error={this.state.error} />
    }

    return this.props.children
  }
}
